"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.PublicVideoApiService = void 0;
const tslib_1 = require("tslib");
const video_1 = require("@wix/wix-vod-api-site-based/dist/src/public/services/video/video");
const to_error_1 = require("../../parsers/to-error");
const env_1 = require("@wix/wix-vod-constants/env");
const common_1 = require("@wix/wix-vod-shared/common");
const public_1 = require("@wix/wix-vod-gql-api/public");
class PublicVideoApiService {
    constructor(httpClient, baseUrl) {
        this.httpClient = httpClient;
        this.baseUrl = baseUrl;
        this.getVideoUrls = (videoId, channelId, instance, baseUrl) => {
            if ((0, common_1.isGraphAPIEnabled)()) {
                if (channelId) {
                    const publicChannelService = new public_1.PublicChannelService(instance, baseUrl);
                    return publicChannelService.getChannelVideoPlayUrls(videoId, channelId);
                }
                const publicVideoService = new public_1.PublicVideoService(instance, baseUrl);
                return publicVideoService.getPlayUrls({
                    id: videoId,
                    type: public_1.VideoPlayType.CONTENT,
                });
            }
            return this.siteBasedPublicVideoService
                .getVideoUrls(videoId, channelId, instance)
                .then((response) => response.data)
                .catch(to_error_1.toError);
        };
        this.getDownloadUrl = (videoId, channelId, instance, baseUrl) => tslib_1.__awaiter(this, void 0, void 0, function* () {
            var _a;
            if ((0, common_1.isGraphAPIEnabled)()) {
                const publicVideoService = new public_1.PublicVideoService(instance, baseUrl);
                return publicVideoService.getDownloadUrl(videoId);
            }
            return video_1.PublicVideo.getDownloadUrl((_a = this.baseUrl) !== null && _a !== void 0 ? _a : env_1.PRODUCTION_HOSTS.catalog, videoId, channelId, instance);
        });
        this.siteBasedPublicVideoService = new video_1.PublicVideo(httpClient, baseUrl);
    }
}
exports.PublicVideoApiService = PublicVideoApiService;
//# sourceMappingURL=video.js.map